import React from "react";

// Discreet Mars / Venus glyphs for treatment gender availability.
// Rendered as inline SVGs so they take on `currentColor`, stay crisp on retina
// and never depend on an icon font. Kept subtle by default so the luxurious
// spa aesthetic isn't disrupted — a card usually shows either one or both.

const base = { className: "inline-block", strokeWidth: 1.75, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" };

export function MaleGlyph({ size = 14, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Available for male guests"
      {...base}
      {...rest}
    >
      {/* circle body */}
      <circle cx="10" cy="14" r="5" />
      {/* arrow up-right */}
      <line x1="14" y1="10" x2="20" y2="4" />
      <polyline points="14 4 20 4 20 10" />
    </svg>
  );
}

export function FemaleGlyph({ size = 14, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Available for female guests"
      {...base}
      {...rest}
    >
      {/* circle body */}
      <circle cx="12" cy="9" r="5" />
      {/* cross tail */}
      <line x1="12" y1="14" x2="12" y2="22" />
      <line x1="9" y1="19" x2="15" y2="19" />
    </svg>
  );
}

/** Row helper — shows only the glyphs whose flag is true. */
export function GenderAvailabilityIcons({ male = true, female = true, size = 14, className = "", testId }) {
  const showMale = !!male;
  const showFemale = !!female;
  if (!showMale && !showFemale) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 text-primary/60 ${className}`} data-testid={testId || "gender-icons"}>
      {showMale && (
        <span title="Available for male guests" aria-label="Available for male guests" className="inline-flex hover:text-accent transition-colors">
          <MaleGlyph size={size} />
        </span>
      )}
      {showFemale && (
        <span title="Available for female guests" aria-label="Available for female guests" className="inline-flex hover:text-accent transition-colors">
          <FemaleGlyph size={size} />
        </span>
      )}
    </span>
  );
}
